/* Version: 3.5.149 */
'use client';
// eslint-disable-next-line import/prefer-default-export
var SOCIAL_MEDIA = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  LINKEDIN: 'linkedin',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube'
};
var DEFAULT_FOOTER_LOGO_STYLE = {
  height: '20px'
};

export { DEFAULT_FOOTER_LOGO_STYLE, SOCIAL_MEDIA };
